import { render, staticRenderFns } from "./ThirdPartyButton.vue?vue&type=template&id=5e210136&scoped=true&"
import script from "./ThirdPartyButton.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyButton.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyButton.vue?vue&type=style&index=0&id=5e210136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e210136",
  null
  
)

export default component.exports